import React from 'react';
import { Wrench, Settings, Clock, FileText, CheckCircle, Star, Phone, MessageCircle } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Wrench,
      title: 'AC Installation & Repair',
      description: 'Professional installation and repair services for all major types of AC units with certified technicians ensuring smooth, quick, and professional execution.',
      image: '/img3.jpg',
      features: [
        'Split AC Systems Installation',
        'Window AC Units Setup', 
        'Central Cooling Systems',
        'Emergency Repair Services',
        'System Diagnostics',
        'Performance Optimization'
      ],
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Settings,
      title: 'Spare Parts Supply',
      description: 'Comprehensive inventory of high-quality, branded AC spare parts including compressors, gauges, remote controls, thermostats, filters, pipes, and more.',
      image: '/Spare.jpg',
      features: [
        'Genuine Branded Parts',
        'Compressors & Motors',
        'Remote Controls & Thermostats',
        'Filters & Coils',
        'Pipes & Fittings',
        'Fast Delivery Service'
      ],
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: Clock,
      title: '24/7 Maintenance Team',
      description: 'Round-the-clock responsive technicians available for urgent servicing, emergency calls, routine maintenance, and system check-ups.',
      image: '/team.jpg',
      features: [
        'Emergency Response',
        'Scheduled Maintenance',
        'System Diagnostics',
        'Preventive Care',
        'Performance Monitoring',
        'Priority Support'
      ],
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FileText,
      title: 'AMC Services',
      description: 'Flexible Annual Maintenance Contracts tailored to your business needs with scheduled servicing, priority response, system check-ups, and discounted repairs.',
      image: '/AM.jpg',
      features: [
        'Customized Service Plans',
        'Priority Response',
        'Cost-Effective Solutions',
        'Regular System Check-ups',
        'Extended Warranty',
        'Discounted Repairs'
      ],
      color: 'from-orange-500 to-orange-600'
    },
    
  ];
   const systems = [
    // 🔹 New Data Added Below 🔹
    {
      icon: Wrench,
      title: 'Chilled Water Systems',
      description:
        'Efficient cooling solutions for large-scale buildings using water-cooled air systems. Ideal for commercial towers, hotels, and industrial facilities.',
      image:
        '/img1.jpg',
      features: [
        'Central Chiller Integration',
        'Energy-Efficient Water Cooling',
        'Custom Pump & Piping Setup',
        'Compatible with BMS Systems',
        'Precision Temperature Control',
        'Routine Maintenance & Servicing',
      ],
      color: 'from-cyan-500 to-cyan-600',
    },
    {
      icon: Settings,
      title: 'VRV/VRF Air-Conditioning Systems',
      description:
        'Advanced variable refrigerant volume/flow systems for zone-based climate control across large spaces.',
      image:
        '/img7.jpg',
      features: [
        'Multi-Zone Climate Control',
        'Heat Recovery Options',
        'Compact & Flexible Installations',
        'Individual Unit Programming',
        'BMS Integration Ready',
        'Low Energy Consumption',
      ],
      color: 'from-pink-500 to-pink-600',
    },
    {
      icon: Clock,
      title: 'District Cooling Systems',
      description:
        'High-efficiency cooling networks for entire buildings, communities, or developments through centralized chilled water supply.',
      image:
        '/District.jpg',
      features: [
        'Central Cooling Distribution',
        'Ideal for Mixed-Use Developments',
        'Lower Operational Costs',
        'Reduced Carbon Footprint',
        '24/7 Central Plant Monitoring',
        'Utility-Scale Reliability',
      ],
      color: 'from-teal-500 to-teal-600',
    },
    {
      icon: FileText,
      title: 'Rooftop Packaged Units',
      description:
        'Powerful rooftop units for centralized ducted air systems, combining compressor, evaporator, and fan in one compact package.',
      image:
        '/top.jpg',
      features: [
        'All-in-One Unit Installation',
        'Ideal for Malls & Warehouses',
        'Customizable Airflow Design',
        'Energy-Efficient Operation',
        'Ducted Air Distribution',
        'Weather-Resistant Housing',
      ],
      color: 'from-yellow-500 to-yellow-600',
    },
    {
      icon: Wrench,
      title: 'Ducted Split Systems',
      description:
        'Concealed ceiling-mounted cooling for villas, clinics, and offices with centralized airflow across multiple rooms.',
      image:
        '/Ducted.jpg',
      features: [
        'Discreet Ceiling-Mounted Units',
        'Quiet Operation',
        'Zonal Air Distribution',
        'Remote & BMS Compatible',
        'Seamless Interior Integration',
        'Ideal for Premium Projects',
      ],
      color: 'from-lime-500 to-lime-600',
    },
    {
      icon: Settings,
      title: 'Precision AC Systems',
      description:
        'Temperature and humidity-controlled cooling for IT rooms, data centers, labs, and clean rooms.',
      image:
        '/Precision.jpg',
      features: [
        'High Sensitivity Cooling',
        'Humidity & Airflow Regulation',
        '24/7 Environmental Monitoring',
        'Redundant Backup Systems',
        'Fire & Smoke Compatible',
        'Uptime Guarantee Support',
      ],
      color: 'from-red-500 to-red-600',
    },
  ];

  const industries = [
    {
      title: 'Commercial Properties',
      description: 'Office buildings, retail stores, and commercial complexes',
      icon: '🏢',
      color: 'from-blue-50 to-blue-100 border-blue-200'
    },
    {
      title: 'Industrial Facilities', 
      description: 'Warehouses, manufacturing plants, and industrial complexes',
      icon: '🏭',
      color: 'from-purple-50 to-purple-100 border-purple-200'
    },
    {
      title: 'Healthcare',
      description: 'Hospitals, clinics, and medical facilities',
      icon: '🏥',
      color: 'from-green-50 to-green-100 border-green-200'
    },
    {
      title: 'Education',
      description: 'Schools, universities, and educational institutions',
      icon: '🎓',
      color: 'from-yellow-50 to-yellow-100 border-yellow-200'
    },
    {
      title: 'Hospitality',
      description: 'Hotels, restaurants, and hospitality businesses',
      icon: '🏨',
      color: 'from-red-50 to-red-100 border-red-200'
    },
    {
      title: 'Residential',
      description: 'Villas, apartments, and residential compounds',
      icon: '🏠',
      color: 'from-indigo-50 to-indigo-100 border-indigo-200'
    }
  ];

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hello! I would like to request a quote for your services.");
    window.open(`https://wa.me/97474408801?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-purple-50 rounded-full px-4 py-2 border border-purple-200 mb-6">
              <span className="text-purple-700 font-medium text-sm">Our Professional Services</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Comprehensive <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">HVAC Solutions</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Professional air conditioning and refrigeration services designed to keep 
              your spaces comfortable with maximum efficiency and minimal downtime.
            </p>
          </div>

          {/* Service Quality Badges */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">
            <div className="bg-green-50 border border-green-200 rounded-full px-6 py-3">
              <div className="flex items-center space-x-2">
                <CheckCircle size={16} className="text-green-600" />
                <span className="text-green-800 font-medium">Certified Technicians</span>
              </div>
            </div>
            <div className="bg-yellow-50 border border-yellow-200 rounded-full px-6 py-3">
              <div className="flex items-center space-x-2">
                <Star size={16} className="text-yellow-600" />
                <span className="text-yellow-800 font-medium">Quality Guaranteed</span>
              </div>
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-full px-6 py-3">
              <div className="flex items-center space-x-2">
                <Clock size={16} className="text-blue-600" />
                <span className="text-blue-800 font-medium">24/7 Available</span>
              </div>
            </div>
          </div>
        </div>
      </section>
       <div className="text-center mb-4">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              General HVAC <span className="text-purple-600">Services</span>
            </h2>
            </div>
      {/* Services Detail */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div
                key={index}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
                }`}
              >
                {/* Content */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''} bg-white rounded-2xl p-8 shadow-lg border border-gray-200`}>
                  <div className="flex items-center mb-6">
                    <div className={`bg-gradient-to-r ${service.color} p-4 rounded-xl mr-4 shadow-lg`}>
                      <service.icon size={28} className="text-white" />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
                  </div>
                  
                  <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-4">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <CheckCircle size={16} className="text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700 text-sm font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Image */}
                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-80 object-cover rounded-xl"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
       <div className="text-center mb-4">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Specialized HVAC <span className="text-purple-600">Systems </span>
            </h2>
            </div>
      {/* Services Detail */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-20">
            {systems.map((service, index) => (
              <div
                key={index}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
                }`}
              >
                {/* Content */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''} bg-white rounded-2xl p-8 shadow-lg border border-gray-200`}>
                  <div className="flex items-center mb-6">
                    <div className={`bg-gradient-to-r ${service.color} p-4 rounded-xl mr-4 shadow-lg`}>
                      <service.icon size={28} className="text-white" />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900">{service.title}</h2>
                  </div>
                  
                  <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                    {service.description}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-4">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <CheckCircle size={16} className="text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700 text-sm font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Image */}
                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-80 object-cover rounded-xl"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Industries We <span className="text-purple-600">Serve</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Delivering specialized HVAC solutions across diverse sectors throughout Qatar
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => (
              <div
                key={index}
                className={`bg-gradient-to-br ${industry.color} border rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2`}
              >
                <div className="text-5xl mb-6">{industry.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{industry.title}</h3>
                <p className="text-gray-600 leading-relaxed">{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-blue-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Experience Professional Service?
          </h2>
          <p className="text-lg text-white/90 mb-8">
            Contact us today for a free consultation and quote. Our team is ready to help 
            with all your air conditioning and refrigeration needs across Qatar.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+97470086090"
              className="bg-white text-purple-600 px-8 py-4 rounded-xl text-lg font-bold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center space-x-2"
            >
              <Phone size={20} />
              <span>Call +974 7008 6090</span>
            </a>
            <button
              onClick={handleWhatsAppClick}
              className="bg-green-500 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-green-600 transition-all duration-300 transform hover:scale-105 shadow-xl flex items-center justify-center space-x-2"
            >
              <MessageCircle size={20} />
              <span>Get Free Quote</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;